
import React from "react";

import withShipment from "../../../../withShipment";


import './TwoStepDelete.css';
import {IconButton} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import TableCell from "@material-ui/core/TableCell";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";


class TwoStepDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  displayTwoStepDelete = () => {
    return (
      <React.Fragment>
        {
          this.props.deleteId !== this.props.rowId ? (
            <IconButton
              disabled={this.props.disabled}
              onClick={(e) => {
                  e.stopPropagation()
                  this.props.setDeleteId(this.props.rowId)
              }
              }
            >
              <DeleteIcon />
            </IconButton>
          ) : (
            <div>
              <IconButton onClick={(e) => {
                  e.stopPropagation()
                  this.props.setDeleteId('')}
              }>
                <CloseIcon />
              </IconButton>

                <IconButton
                    >
                    <DeleteIcon
                        style={{ color: 'red' }}
                        onClick={(e) => {
                            e.stopPropagation()
                            this.props.handleDelete(this.props.rowId)}
                        }
                        disabled={this.props.rowId !== this.props.deleteId}
                       />
                </IconButton>

            </div>
          )
        }
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.props.noTableCellContainer ? (
          <div className={'defaultTableCellStyle'}>
            {this.displayTwoStepDelete()}
          </div>
        ) : (
          <TableCell className={'defaultTableCellStyle'}>
            {this.displayTwoStepDelete()}
          </TableCell>
        )}
      </React.Fragment>
    );
  }
}

TwoStepDelete.defaultProps = {
    disabled: false
}

TwoStepDelete.propTypes = {
    rowId: PropTypes.string,
    handleDelete: PropTypes.func,
    deleteId: PropTypes.string,
    setDeleteId: PropTypes.func,
    disabled: PropTypes.bool,
}

const mapStateToProps = (state) => ({
})

const actionCreators = {
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, TwoStepDelete);